import React from "react";

const WhatsappCenteredButton = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <p className="mb-3" style={{ fontSize: "15px", color: "#555", maxWidth: "90%" }}>
        Having a general issue or can't find what you're looking for? Feel free to reach out via WhatsApp. Just click the button below and our team will assist you.
      </p>
      <a
        href="https://api.whatsapp.com/send?phone=923242229339"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img height={50} src="https://alahdeen.com/pro/image/whatsapp.png" alt="Start WhatsApp Chat" />
      </a>
    </div>
  );
};

export default WhatsappCenteredButton;
